import { compose } from "modules/core";
import TeamAssessmentReportView from "modules/poc-dashboard/components/dashboard/teamAssessmentReportView";
import React from "react";
import { withApollo } from '@apollo/client/react/hoc'
import { ASSESSMENT_RESPONSE_SET_FOR_EMPLOYEE, SURVEY_BY_ID_FOR_REPORT, TEAM_ASSESSMENT_REPORTS } from "modules/poc-dashboard/graphql/pocDashboardQuery.gql";
import { getSurveyBase64StringFromInt } from "modules/look";
import { getOrgID } from "../organization/organizationOperations";
import { ORGANIZATION_EMPLOYEE } from "modules/poc-dashboard/graphql/organizationQuery.gql";
const TeamAssessmentContainer = (props) => {
  const { client, me, history, orgToFetchData, navigateRoute } = props
  const [SurveyReport, setSurveyReport] = React.useState()
  const [surveyDetail, setSurveyDetail] = React.useState()
  const [employees, setEmployees] = React.useState([])
  const [responseSet, setresponseSet] = React.useState()

  const getSurveyReport = async (filterData) => {
    try {
      const { data } = await client.query({
        query: TEAM_ASSESSMENT_REPORTS,
        variables: {
          ...filterData,
          orgId: getOrgID(props) || orgToFetchData?.id
        }
      });
      if (data?.organizationById) {
        let report = data?.organizationById?.employees?.edges[0]?.node?.user?.responseSet?.edges[0]?.node?.report360
        if (report) {
          let report360 = JSON.parse(report)
          setSurveyReport({ report360 })
        } else {
          setSurveyReport(null)
        }

      } else {
        setSurveyReport(null)
      }
    } catch (error) {
      console.error("TeamAssessmentReportContainer -> getSurveyReport", error)
    }
  }
  const getResponseSet = async (filterData) => {
    try {
      let filter = { ...filterData, survey: getSurveyBase64StringFromInt(props?.match?.params?.survey_id) }
      const { data } = await client.query({
        query: ASSESSMENT_RESPONSE_SET_FOR_EMPLOYEE,
        variables: {
          ...filter,
          id: getOrgID(props) || orgToFetchData?.id
        },
        fetchPolicy: "network-only"
      });
      if (data?.organizationById) {
        setresponseSet(data?.organizationById?.employees)
      }
    } catch (error) {
      console.error("TeamAssessmentReportContainer -> getResponseSet", error)
    }
  }

  // const getEmployeeDetail = async () => {
  //   const { data } = await client.query({
  //     query: POC_MANAGER_EMPLOYEE_DETAIL,
  //   });
  //   if (data?.me) {
  //     let Detail = data?.me?.employee
  //     if (Detail?.teamManagerEmployee?.totalCount || Detail?.orgCeoEmployee?.totalCount || Detail?.orgPocEmployee?.totalCount || Detail?.verticalHeadEmployee?.totalCount) {
  //       let employees = []
  //       if (Detail?.orgCeoEmployee?.totalCount) {

  //         employees = employees.concat(Detail?.orgCeoEmployee?.edges?.map(({ node }) => node?.employees?.edges))
  //       }
  //       if (Detail?.teamManagerEmployee?.totalCount) {
  //         employees = employees.concat(Detail?.teamManagerEmployee?.edges?.map(({ node }) => node?.employees?.edges))
  //       }
  //       if (Detail?.orgPocEmployee?.totalCount) {

  //         employees = employees.concat(Detail?.orgPocEmployee?.edges?.map(({ node }) => node?.employees?.edges))
  //       }
  //       if (Detail?.verticalHeadEmployee?.totalCount) {
  //         employees = employees.concat(Detail?.verticalHeadEmployee?.edges?.map(({ node }) => node?.employees?.edges))
  //       }


  //       employees = [].concat.apply([], employees)
  //       var setObj = new Set(); // create key value pair from array of array

  //       var result = employees.reduce((acc, item) => {
  //         if (!setObj.has(item.node?.user?.id)) {
  //           setObj.add(item.node?.user?.id)
  //           acc.push(item)
  //         }
  //         return acc;
  //       }, [])
  //       result = result.map(({ node }) => node?.user)
  //       setEmployees(result)
  //     }
  //     else {
  //       history.push('/home')
  //     }

  //   }
  // }

  const getEmployeeDetail = async () => {
    const { data } = await client.query({
      query: ORGANIZATION_EMPLOYEE,
      variables: {
        id: getOrgID(props) || orgToFetchData
      }
    });
    if (data?.organizationById?.employees?.edges?.length) {
      setEmployees(data?.organizationById?.employees?.edges?.map(({ node }) => node?.user))
    } else {
      navigateRoute("/home")
    }
  }

  const getSurveyDetail = async (filter) => {
    const { data } = await client.query({
      query: SURVEY_BY_ID_FOR_REPORT,
      variables: filter
    });

    if (data?.SurveyById) {
      setSurveyDetail(data?.SurveyById)
    }
  }

  React.useEffect(() => {
    if (me) {
      if (props?.match?.params?.survey_id) {
        let id = getSurveyBase64StringFromInt(props?.match?.params?.survey_id)
        getSurveyDetail({ id: id })
        getEmployeeDetail()
      }
    }
    else if (me === null) {
      history.push('/user/login')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me, orgToFetchData])

  return (
    <>
      <TeamAssessmentReportView
        {...props}
        SurveyReport={SurveyReport}
        surveyDetail={surveyDetail}
        employees={employees}
        changeUser={(e) => { getResponseSet(e) }}
        responseSet={responseSet}
        get360Report={(e) => { getSurveyReport(e) }} />
    </>
  )
}

export default compose(withApollo)(TeamAssessmentContainer)